import { TaPresenterForMap } from './ta_presenter_map'

export default TaPresenterForMap